export const remindersReducerTypes = {
  SET_REMINDER: "SET_REMINDERS",
  REMOVE_REMINDER: "REVMOE_REMINDERS",
  SET_REMINDER_MODAL_STEP: "SET_REMINDER_MODAL_STEP",
  SET_MESSAGE_MODAL_OPEN: "SET_MESSAGE_MODAL_OPEN",
  SET_REMINDERS_MODAL_INFO: "SET_REMINDERS_MODAL_INFO",
  SET_MESSAGE_MODAL_CLOSE: "SET_MESSAGE_MODAL_CLOSE",
  SET_REMINDERS_MODAL_CLOSE: "SET_REMINDERS_MODAL_CLOSE",
};
